import React, {useState, useCallback} from 'react'
import './loading.styles.css'
//////////////////////////////////////
interface ILoadingValues {
  showLoading: boolean
  handleOpen: () => void
  handleClose: () => void
}
const LoadingInitialValues: ILoadingValues = {
  showLoading: false,
  handleOpen: () => {},
  handleClose: () => {},
}
const LoadingContext = React.createContext(LoadingInitialValues)
//
const LoadingContextProvider = ({children}: {children: React.ReactNode}) => {
  const [showLoading, setShowLoading] = useState<boolean>(false)
  const handleOpen = useCallback(() => {
    setShowLoading(true)
  }, [])
  const handleClose = useCallback(() => {
    setShowLoading(false)
  }, [])
  // RENDER
  return (
    <LoadingContext.Provider
      value={{
        showLoading,
        handleOpen,
        handleClose,
      }}
    >
      {children}
      {showLoading && (
        <div className='lds-ripple-container d-flex flex-row justify-content-center align-items-center'>
          <div className='lds-ripple'>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  )
}

export default LoadingContextProvider
export const useLoadingContext = () => React.useContext(LoadingContext)
